import { createAsyncThunk } from '@reduxjs/toolkit'
import { getGeneralReportService } from 'network/services/reports/generalReports.service'

export const fetchGeneralReport = createAsyncThunk(
  'fetch/allGeneralReport',
  async ({ params }, thunkApi) => {
    try {
      const res = await getGeneralReportService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
